import React from 'react';
import styled from '@emotion/styled';
import checkIcon from '../assets/icons/check.png';

interface VerificationStatusProps {
  isAuthentic: boolean;
}

export const VerificationStatus: React.FC<VerificationStatusProps> = ({ isAuthentic }) => {
  return (
    <Container>
      <StatusIcon>
        <img src={checkIcon} alt="인증 성공" style={{ width: '100%', height: '100%' }} />
      </StatusIcon>
      <StatusTitle>
        {isAuthentic ? '정품 인증 성공' : '정품 인증 실패'}
      </StatusTitle>
      <StatusDescription>
        {isAuthentic 
          ? '이 제품은 정품 인증된 제품입니다.' 
          : '이 제품은 정품이 아닙니다.'}
      </StatusDescription>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
`;

const StatusIcon = styled.div`
  width: 72px;
  height: 72px;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StatusTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
`;

const StatusDescription = styled.p`
  font-size: 16px;
  color: #666;
  text-align: center;
`;